export function enhanceLinksWithData({ links, user }) {
  return links.map(link => {
    switch (link.name) {
      case 'enquiries': {
        return {
          ...link,
          options: {
            ...link.options,
            value: user.newEnquiries,
          },
        };
      }
      case 'userEnquiries': {
        return {
          ...link,
          options: {
            ...link.options,
            value: user.unreadEnquiries,
          },
        };
      }
      case 'favorites': {
        return {
          ...link,
          options: {
            ...link.options,
            value: user.wishList.length,
          },
        };
      }
      case 'reviews': {
        return {
          ...link,
          options: {
            ...link.options,
            value: user.reviewsCount,
          },
        };
      }
      default:
        return link;
    }
  });
}
